module.exports = __webpack_public_path__ + "static/img/Clare-Wheeler.ef25d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clare-Wheeler.jpg
// module id = Iym3
// module chunks = 0